import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
//import 'rxjs/add/operator/takeUntil';
import { take, takeUntil } from 'rxjs/operators';


// services
import { AppStateService } from '../../../shared/services/app-state.service';
import { EventsService } from '../../services/events.service';
import { BookingService } from '../../services/booking.service';
import { CollectionService } from '../../services/collection.service';
import { PriceService } from '../../services/price.service';
import { MilesAndMore } from '../../services/miles-n-more.service';
import { PaymentService } from '../../services/payment.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { LoginService } from '../../../shared/services/login.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { CompleteBookingService } from '../../../my-account/services/complete-bookings.service';
import { AddQuestionAnswerService } from '../../../shared/services/add-question-answer.service';
import { SharedService } from '../../../shared/services/shared-service.service';
import { ExternalScriptsService } from '../../../shared/services/external-scripts.service';
import { CopyService } from '../../../shared/services/app-copy.service';

// models
import { AppState } from '../../models/app-state.interface';

// external libs
import { PORTR_CRM_POPUPS } from '../../../shared/globals';
import moment from 'moment';

declare var zE: any;

@Component({
  selector: 'app-booking-section',
  templateUrl: './booking-section.component.html',
  styleUrls: ['./booking-section.component.scss'],
  providers: [
    AppStateService,
    CollectionService,
    PriceService,
    PaymentService,
    DataStorageService,

    CompleteBookingService,
    AddQuestionAnswerService,
    LoginService,
    SharedService
  ]
})
export class BookingSectionComponent implements OnInit, OnDestroy {

  private _userLanguageSubscription: Subscription;
  private _onDestroy$ = new Subject();
  private _bookingInitSubscription: Subscription;
  private _userSubscription: Subscription;
  private _bookingSubscription: Subscription;
  private _bookingStateSubscription: Subscription;
  private _newBookingReferenceSubscription: Subscription;
  private _hubdropSubscription: Subscription;
  private _milesStateSubscription$: Subscription;
  private _currentBookingProduct = '';
  private _panelChanged: Boolean = false;
  private _isFirstLoad: Boolean = true;
  private _state;
  private _lastPanel = 1;
  private _dataLinkVariableSubscription: Subscription;

  public dataLinkReset: any;
  public user;
  public booking;
  public currentBooking;
  public bookingType = '';
  public bookingState;
  public currentPanel;
  public hubdrop;
  public currentPartner = null;
  public bookingInit: Boolean = false;
  public flightData;

  public appCopy;
  public selectedLanguage = '';

  constructor(
    private _appStateService: AppStateService,
    private _eventsService: EventsService,
    private _bookingService: BookingService,
    private _priceService: PriceService,
    private _dataStorageService: DataStorageService,
    private _appStore: Store<AppState>,
    private _router: Router,
    private _route: ActivatedRoute,
    private _errorHandler: ErrorHandler,
    private _loginService: LoginService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _sharedService: SharedService,
    private _externalScriptsService: ExternalScriptsService,
    private _copyService: CopyService,
    private _milesAndMoreService: MilesAndMore,
  ) { }

  ngOnInit() {

    this._appStore.dispatch({ type: 'CURRENT_BOOKING_LOADED', payload: false });
    // this._appStore.dispatch({ type: 'COPY_LOADED', payload: false });

    // get airports data on server
    // used in booking flow
    this._sharedService.getAirports();

    this._state = this.getState(this._appStore);
    if (isPlatformBrowser(this.platformId)) {
      const airlineCode = this._state.bookingReducer.bookingDetails.carrier.airlineCode;
      const lastBookingType = this._state.oldBookingInfoReducer.d2dReducer?.currentBookingProduct;
      let bookingData;
      if (lastBookingType) {
        bookingData = lastBookingType === 'abc' ? this._state.oldBookingInfoReducer.d2dReducer.outboundBooking : this._state.oldBookingInfoReducer.d2dReducer.inboundBooking;
      }
      if (!airlineCode && (bookingData && !bookingData.bookingReducer.bookingDetails.carrier.airlineCode)) {
        setTimeout(() => {
          const state = this.getState(this._appStore).flightFinderReducer;
          const url = state.returnCustomerUrl;
          if (url) {
            window.location.replace(url);
          } else {
            this._router.navigate(['flight-finder/search']);
          }
        }, 3000);
      }
      this.setBookingState();

      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.bookingInit = res.currentBookingLoaded;

          if (res.currentBookingLoaded && this._isFirstLoad) {

            if (this.bookingType === 'incomplete') {
              this._appStateService.setBookingType('refresh');
            }

            if (res.copyLoaded) {
              this.getCopy();
            }

            this.setDataSubscriptions();
          } else {
            return;
          }
        });

      // use to watch for back/forward browser clicks
      window.addEventListener('popstate', () => this.handleBrowserNavigation());
    };

    this._dataLinkVariableSubscription = this._bookingService.dataLinkVariableUpdated.subscribe(
      (val) => {
        console.log(val);
        this.dataLinkReset = val;
      }
    );

  }

  cancelModal() {
    this.dataLinkReset = false;
  }

  goToFlightFinder() {
    this._appStateService.resetCurrentBookingData();
    this._appStateService.resetPanelNumber();
    this._appStateService.resetFlightFinderData();
    this._appStateService.resetTimeslotData();
    this._appStateService.resetHubDropReducer();
    this._appStore.dispatch({ type: 'UPDATE_PARTNER_NAME', payload: { partnerName: 'NONE' } });

    this._router.navigate(['flight-finder/search']
      , { queryParams: { 'start-booking': true } });
  }

  getCopy() {

    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'Modal',
      ['panelHeader']
    );


    const panelHeaderCopy1 = this._copyService.getCopyBySection(
      'OTHER',
      'overview',
      [this._bookingService.currentBooking.bookingJourney[0].journeyDirection === 1 ? 'outbound' : 'inbound']
    );

    console.log(panelHeaderCopy)

    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
      panelHeaderCopy1: panelHeaderCopy1[0],
    };

  }

  setDataSubscriptions() {

    this._state = this.getState(this._appStore);
    if (!this._state.bookingReducer.bookingDetails.carrier.airlineCode) {
      setTimeout(() => {
        const state = this.getState(this._appStore).flightFinderReducer;
        const url = state.returnCustomerUrl;
        if (url) {
          window.location.replace(url);
        } else {
          this._router.navigate(['flight-finder/search']);
        }
      }, 100);
    }
    this.bookingType = this._state.bookingReducer.bookingDetails.bookingType;

    this.currentPartner = this.getState(this._appStore).partnerReducer.partnerName;

    this._userSubscription = this._appStore.select('userReducer')
      .subscribe((u: any) => {
        this.user = <AppState>u;
        if (this.user.userDetails.userTokenValid) {
          this._bookingService.setApiToken(this.user.userDetails.userToken);
        }
      });

    this._userLanguageSubscription = this._appStore.select('copyReducer')
      .subscribe((res: any) => {
        this.selectedLanguage = res.language
      })

    this._bookingSubscription = this._appStore.select('currentBookingReducer')
      .subscribe((booking: any) => {
        this.currentBooking = booking.currentBooking;
      });

    this._bookingStateSubscription = this._appStore.select('bookingReducer')
      .subscribe((bookingState: any) => {
        this.bookingState = <AppState>bookingState;
      });

    this._hubdropSubscription = this._appStore.select('hubDropReducer')
      .subscribe((hubdropState: any) => {
        this.hubdrop = hubdropState;
      });

    // watch panel reducer - navigate to url based on number value
    this._appStore.select('updatePanelReducer')
      .pipe(takeUntil(this._onDestroy$))
      .subscribe((p: any) => {
        // stop error thrown if p is 0, redirect to first panel
        if (p === 0) { p = 1; }

        if (!this.bookingInit) {
          return;
        }

        this.currentPanel = p;

        // check if not number
        // this can happen when pressing browser back button from flight request
        if (isNaN(this.currentPanel)) {
          return;
        }

        // set panel view
        // check product type
        console.log(this.currentPanel, this._currentBookingProduct)
        this._router.navigate([this._eventsService.getURLPath(this.currentPanel, this._currentBookingProduct)], { queryParamsHandling: 'preserve' });
        this._panelChanged = true;

        // below saves data on panel changes (json store data)
        // and also calls addBooking to store an incomplete - if logged in and not amend
        if (!this._isFirstLoad) {

          // save data to api if panel is > 1
          this._dataStorageService.saveData();

          const userLoggedIn = this.user.userDetails.userLoggedIn;

          // save incomplete if values are ok
          let minPanelToSaveBooking = 2;
          if (this.hubdrop.selectedCollectionType === 'atAddress') {
            minPanelToSaveBooking = 3;
          }

          if (
            !(this.currentBooking.bookingCompletion && this.currentBooking.bookingCompletion.bookingComplete) &&
            this.currentPanel !== this._lastPanel &&
            this.currentPanel > minPanelToSaveBooking &&
            (userLoggedIn) &&
            this.bookingState.bookingDetails.bookingType !== 'amend'
          ) {
            this._bookingService.postBooking(userLoggedIn);
          }

        }

        this._lastPanel = this.currentPanel;
        this._isFirstLoad = false;

      });

    this._newBookingReferenceSubscription = this._errorHandler.createNewBookingReference$
      .subscribe(value => {
        if (value) {
          this._bookingService.getBookingReferenceForRequest();
        }
      });

    // check miles&more login
    this._milesStateSubscription$ = this._milesAndMoreService.milesLoading$
      .subscribe(res => {
        if (res === 'success') {
          if (this.bookingState.bookingDetails.bookingProduct === 'abc' && this.bookingState.bookingDetails.carrier.airlineCode === 'LX') {
            this._bookingService.setMilesPromotion(this._priceService);
          }
        }
      });

    this._priceService.getPrice();
    this.loadCRMPopups();
  }

  loadCRMPopups() {
    const userEmail = this._dataStorageService.checkCookie('PortrE');
    const hasPromo = this.getState(this._appStore).flightFinderReducer.promoFromUrl !== null;

    // only if new user and didn't land on funnel with a promo
    // if (!userEmail && !hasPromo) {
    //   const options = {
    //     id: 'portr-crm-popups',
    //     src: PORTR_CRM_POPUPS
    //   };

    //   this._externalScriptsService.loadScript(options);
    // }
  };


  handleBrowserNavigation() {
    const currentUrl = window.location.pathname;
    const splitUrl = currentUrl.split('/').slice(1);
    const ind = this._eventsService.getUrlIndex(splitUrl[1]);

    const body = document.getElementsByTagName('body')[0];
    if (body.classList.contains('modal-open')) {
      this._errorHandler.removeModal();
    }
    this._appStore.dispatch({ type: 'PANEL_SET', payload: (ind + 1) });
  };

  setBookingState() {
    this._currentBookingProduct = this._state.bookingReducer.bookingDetails.bookingProduct;
    this.bookingType = this._state.bookingReducer.bookingDetails.bookingType;
    // set app state
    // pass in bookingProduct if needed, booking type if needed
    // service to determine if new/refreshed booking and store values
    this._appStateService.setAppState(this.bookingType, this._currentBookingProduct);
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  openChat() {
    zE.activate();
  }

  ngOnDestroy() {
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
    if (this.bookingInit) {
      this._onDestroy$.next(1);
      this._userSubscription.unsubscribe();
      this._bookingSubscription.unsubscribe();
      this._bookingStateSubscription.unsubscribe();
      this._newBookingReferenceSubscription.unsubscribe();
      this._dataLinkVariableSubscription.unsubscribe();
      this._hubdropSubscription.unsubscribe();
      if (this._milesStateSubscription$) { this._milesStateSubscription$.unsubscribe(); }

      if (isPlatformBrowser(this.platformId)) {
        this._bookingInitSubscription.unsubscribe();
      }
    }
  }

}
